// @flow
import { combineActions, handleActions } from 'redux-actions';

import { upsertResource, upsertResources, upsertResourceSetupUndo, completeWithError, resetResources } from 'data/qcsSyncResourceReducerHelpers';

import * as actions from './actions';
import { mkTripsStore } from './types';

const tripsReducer = handleActions({
  [actions.createTrip]: (state) => state.set( 'isLoading', true),
  [actions.createTripSuccess]:
    (state, action) => upsertResourceSetupUndo(state, action, actions.deleteTrip),

  [actions.updateTrip]:
    (state, action) => upsertResourceSetupUndo(state, action, actions.updateTrip),
  [actions.updateTripSuccess]:
    (state, { payload: trip }) => upsertResource(state, trip),

  [actions.deleteTrip]:
    (state, action) => upsertResourceSetupUndo(state, action, actions.createTrip),
  [actions.deleteTripSuccess]:
    (state, { payload: trip }) => upsertResource(state, trip),

  [actions.getTrips]:
    (state) => state.set( 'isLoading', true),
  [actions.getTripsSuccess]:
    (state, { payload: data }) => upsertResources(state, data),
  [actions.getTripsFailure]:
    (state, { payload: error }) => completeWithError(state, error),

  [combineActions(
    actions.createTripFailure,
    actions.updateTripFailure,
    actions.deleteTripFailure,
  )]: (state, { payload: error, asyncDispatch }) => {
    asyncDispatch(actions.getTrips());
    return resetResources(state, error);
  },

}, mkTripsStore());

export const REDUCER_KEY = 'tripsStore';
export default tripsReducer;
